import { Button, Modal } from 'antd';
import { Fragment, useCallback, useContext, useState } from 'react';
import { UserContext } from '../context/UserProvider';
import { API } from '../api';
import { notifyError } from '../store/utils';
import { useNavigate } from 'react-router-dom';
import { BoxIcon, LoginIcon, SearchIcon } from '../lib/LandingIcons';

interface TermType {
  visible: boolean;
  result?: any;
}

const Home = () => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const [state, setState] = useState<any>({
    phone: '',
  });
  const [term, setTerm] = useState<TermType>({
    visible: false,
  });
  const [alertShow, changeAlertShow] = useState<boolean>(false);
  const fetchTerms = useCallback(async () => {
    try {
      const { result } = await API.get({ apiVersion: 'api' })(`/settings/pages/service`);
      setTerm({
        visible: true,
        result: result,
      });
    } catch (error: any) {
      notifyError(error.message);
      ok();
    }
  }, []);

  const ok = () => {
    window.location.href = '/customer-order';
  };

  const search = useCallback(
    (e?: React.FormEvent) => {
      e?.preventDefault();
      const code = (state.phone || '').trim().toUpperCase();
      if (code) {
        navigate('/track?code=' + encodeURIComponent(code));
      }
    },
    [state]
  );

  return (
    <Fragment>
      <div className="hm-page">
        <div className="hm-mid">
          <div className="hm-card">
            <div className="hm-brand">
              <img className="hm-mp" src="/images/mongolpost-logo.png" alt="Монгол Шуудан" />
              <span className="hm-sep" />
              <img className="hm-md" src="/images/logo.png" alt="MyDelivery" />
            </div>
            <p className="hm-tag">Гараас гарт шуурхай хүргэлтийн систем</p>
            <div className="hm-actions">
              <button
                type="button"
                className="hm-btn hm-pri"
                onClick={() => {
                  // logged-in users go to the dashboard, everyone else straight to login
                  navigate(user ? '/dashboard' : '/auth/login');
                }}
              >
                <LoginIcon />
                Нэвтрэх
              </button>
              <button type="button" className="hm-btn hm-sec" onClick={() => fetchTerms()}>
                <BoxIcon />
                Захиалга өгөх
              </button>
            </div>
            <div className="hm-divider">илгээмжээ шалгах</div>
            <form className="hm-field" onSubmit={search}>
              <SearchIcon className="hm-si" />
              <input
                placeholder="Илгээмжийн дугаар"
                value={state.phone}
                onChange={(e) => setState({ ...state, phone: e.target.value })}
                autoCapitalize="characters"
                autoComplete="off"
                spellCheck={false}
              />
              <button type="submit" className="hm-go">
                Шалгах
              </button>
            </form>
            <p className="hm-hint">Жишээ: MD104857362MN</p>
          </div>
        </div>
        <p className="hm-powered">
          <span>Powered by MongolPost 2026</span>
        </p>
      </div>
      <Modal
        title={term?.result?.title || ''}
        open={term.visible}
        onOk={() => setTerm({ visible: false })}
        onCancel={() => setTerm({ visible: false })}
        okText="Тийм"
        cancelText="Үгүй"
      >
        <div>Одоогоор захиалга өгөх боломжгүй байна</div>
        {/* <div dangerouslySetInnerHTML={{ __html: term?.result?.content }} /> */}
      </Modal>
      <Modal
        title={'Мэдэгдэл'}
        open={alertShow}
        footer={[
          <Button type="primary" onClick={() => changeAlertShow(false)}>
            Хаах
          </Button>,
        ]}
        onCancel={() => changeAlertShow(false)}
      >
        <div>
          <center>
            2026.09.26 буюу Бямба гаригт "Автомашингүй өдөр, замын хөдөлгөөн түр хязгаарлагдахтай
            холбоотойгоор хүргэлтийн үйлчилгээ амрах болсныг мэдэгдэж байна.
            <br /> 🗓 Амрах өдөр: 2026.09.26 📍
            <br /> Хүргэлт хэвийн үргэлжлэх өдөр: 2026.09.28 Тухайн хугацаанд үүсэх сааталд хүлцэл
            өчье. Бидэнд хандан үйлчлүүлдэг та бүхэнд баярлалаа.
          </center>
        </div>
        {/* <div dangerouslySetInnerHTML={{ __html: term?.result?.content }} /> */}
      </Modal>
    </Fragment>
  );
};

export default Home;
